angular.module('impactx.demandbundle').controller('DemandBundleDoneListCtrl', ['selectedListItems',
    '$scope',
    '$redirect',
    DemandBundleDoneListCtrl]);

function DemandBundleDoneListCtrl(selectedListItems , $scope, $redirect) {
    var ctrl = this;

    this.getOrderLink = function() {
        return "demanddetail/" + selectedListItems.getFirstSelectedId();
    };

    var buttonDefinition = [
        {
            label: "details",
            linkFunction: ctrl.getOrderLink,
            type: 'link',
            condition: selectedListItems.isSingleSelection,
            process: 'BundlePositions'
        }
    ];
    this.meta = {
        rowTemplate: 'modules/demandbundle/templates/demandbundlelist.row.tmpl.html',
        filtersTemplate: 'modules/demandbundle/templates/demandbundlelist.filters.tmpl.html',
        isSelectAble: true,
        ctrl: this,
        endpoint: '/demandbundle/donelist',
        id: "demandbundledonelist",
        hasDateFilter: true,
        buttonDefinition: buttonDefinition,
        excelExport: true
    };
    this.getMeta = function() {
        return this.meta;
    };

    ctrl.status = "done";
    $scope.$watch(function() {
        return ctrl.status;
    }, function(current, original) {
        if(current == "open")
            $redirect.redirectTo(null, "/demandbundlelist");
    });
}